import React from 'react'

const MonitorK8sCluster = () => {
  return (
    <div>MonitorK8sCluster</div>
  )
}

export default MonitorK8sCluster